import React from 'react';
import { Box, Typography, Paper, Button } from '@mui/material';
import closeIcon from '../../../assets/icons/closeIcon.svg';

export const Tooltip = ({ onClose }: { onClose: () => void }) => {
  return (
    <Box
      sx={{
        maxWidth: 400,
        borderRadius: '0.9375rem',
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        display: 'flex',
        flexDirection: 'column'
      }}
      component={Paper}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          padding: '1rem 1rem 0 1rem'
        }}
      >
        <Button
          onClick={onClose}
          sx={{ padding: 0, marginLeft: 'auto', minWidth: 0 }}
        >
          <img src={closeIcon} alt="Close" />
        </Button>
      </Box>
      <Box sx={{ padding: '0 1rem 1rem 1rem' }}>
        <Typography
          align="left"
          sx={{
            fontFamily: 'CalibriBoldItalic',
            fontSize: '1rem',
            lineHeight: '1.25rem',
            color: '#004F71',
            paddingBottom: '0.625rem'
          }}
        >
          Reference:
        </Typography>
        <Typography
          align="left"
          sx={{
            fontFamily: 'Calibri',
            fontSize: '1rem',
            fontWeight: 400,
            lineHeight: '1.25rem',
            color: '#004F71'
          }}
        >
          Irish Nutrition and Dietetic Institute (2022) Nutrition Support
          Reference Guide.
        </Typography>
      </Box>
    </Box>
  );
};
